import { useEffect } from 'react';
import { Justification_APIC } from '../constants/spread';

/**
 * Calculate the estimated price
 *
 * @param {object} intl used for the formatting
 * @param {string} lang the language code to get the currency sign for
 * @param {number} numberFullTimeEmployee : Number of full time employee doing API development/management
 * @param {number} timeSpentPerDeveloper : Percent of time developer spend doing API development/management
 * @param {number} hoursWorkedYearly : Hours worked per employee per year
 * @param {number} avgBurdenCost : Average of salary roles table:  https://www.ziprecruiter.com/Salaries/API-Developer-Salary
 * @returns {Array}
 */

export interface PropsFunc {
  numberFullTimeEmployee: number;
  timeSpentPerDeveloper: number;
  hoursWorkedYearly: number;
  avgBurdenCost: number;
  setHoursSaving: React.Dispatch<React.SetStateAction<number>>;
  setYearlySaving: React.Dispatch<React.SetStateAction<number>>;
}

export interface IFetchError {
  status: number;
  statusText: string;
}

export const usePrice = ({
  numberFullTimeEmployee,
  timeSpentPerDeveloper,
  hoursWorkedYearly,
  avgBurdenCost,
  setHoursSaving,
  setYearlySaving,
}: PropsFunc) => {
  let hoursSavedPerEmployee = 0;
  let totHoursSavedPerEmployee = 0;

  useEffect(() => {
    const totalHoursSaved = determine_hoursSavedTotEmp();
    setHoursSaving(totalHoursSaved);
    const yearlySaving = determine_Savings();
    setYearlySaving(yearlySaving);
  }, [
    numberFullTimeEmployee,
    timeSpentPerDeveloper,
    hoursWorkedYearly,
    avgBurdenCost,
  ]);

  const determine_hoursSavedTotEmp = () => {
    const hoursSavedPerEmpl = Math.round(
      (timeSpentPerDeveloper / 100) *
        hoursWorkedYearly *
        (Justification_APIC / 100),
    );
    hoursSavedPerEmployee = hoursSavedPerEmpl;
    const hoursSavedTotalEmployee = Math.round(
      hoursSavedPerEmpl * numberFullTimeEmployee,
    );
    totHoursSavedPerEmployee = hoursSavedTotalEmployee;
    return hoursSavedTotalEmployee;
  };
  const determine_Savings = () => {
    const TotalSavings = Math.round(
      (avgBurdenCost / hoursWorkedYearly) * totHoursSavedPerEmployee,
    );
    return TotalSavings;
  };
};
